import type { TutorialStep } from "./types.js";

export const DEFAULT_MESSAGE_AUTO_ADVANCE_MS = 15_000;

export function resolveAutoAdvanceMs(
  step: TutorialStep,
  defaultMessageAutoAdvanceMs: number,
): number {
  if (step.autoAdvanceMs > 0) return step.autoAdvanceMs;
  if (step.advance === "action") return 0;
  if (!step.messageKey) return 0;
  return Math.max(0, defaultMessageAutoAdvanceMs);
}
